import { DateTime } from "luxon";

function sortDateTime(dateTimeUtcA: string | null, dateTimeUtcB: string | null): number {
  if (dateTimeUtcA == null && dateTimeUtcB == null) {
    return 0;
  } else if (dateTimeUtcA == null) {
    return -1;
  } else if (dateTimeUtcB == null) {
    return 1;
  }

  return DateTime.fromISO(dateTimeUtcA).toMillis() - DateTime.fromISO(dateTimeUtcB).toMillis();
}

export { sortDateTime };
